import styled from "styled-components";

import { Fonts } from "assets/fonts";

import { Pill } from "./pill";

const StyledPill = styled(Pill)<{ withColor?: boolean }>`
  position: relative;
  border: 1px solid ${(p) => p.theme.borderMediumContrast};
  background: ${(p) => p.theme.bgHighestContrast};
  border-radius: 4px;
  padding: 2px 8px 2px ${(p) => (p.withColor ? "16px" : "8px")};
  ${Fonts.semiBold_12}
`;
const ColorMark = styled.span<{ color: string }>`
  position: absolute;
  left: -1px;
  top: -1px;
  bottom: -1px;
  width: 12px;
  display: block;
  border-radius: 4px 0 0 4px;
  background-color: ${(p) => p.color};
`;

const Name = styled.span`
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

interface TeamTagProps {
  className?: string;
  name: string;
  color?: string;
}
export const NameTag = (props: TeamTagProps) => {
  const { className, name, color } = props;

  return (
    <StyledPill className={className} title={`${name} team`} withColor={!!color}>
      {color && <ColorMark color={color} />}
      <Name>{name}</Name>
    </StyledPill>
  );
};
